import { render, staticRenderFns } from "./regionalDirectorAdd.vue?vue&type=template&id=068e6f7e&scoped=true&"
import script from "./regionalDirectorAdd.vue?vue&type=script&lang=js&"
export * from "./regionalDirectorAdd.vue?vue&type=script&lang=js&"
import style0 from "./regionalDirectorAdd.vue?vue&type=style&index=0&id=068e6f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e6f7e",
  null
  
)

export default component.exports